module.exports = __webpack_public_path__ + "static/media/janneth.00cf693b.png";